import { memo } from 'react';

import { cn } from '../../lib/styles';
import { PageHeader, PageHeaderProps } from '../../designSystem';

interface RightRailLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const RightRailHeader = ({
  bottom,
  onClose,
  noBorder,
  className,
  ...rest
}: PageHeaderProps & { bottom?: React.ReactNode; onClose?: () => void; noBorder?: boolean }) => {
  return (
    <div className={cn('flex flex-col', !noBorder && 'border-b border-border-default')}>
      <PageHeader className={cn('p-4 gap-2', className)} {...rest} />

      {bottom}
    </div>
  );
};

const RightRailLayoutBase = ({ children, className }: RightRailLayoutProps) => {
  return <div className={cn('flex flex-col shadow-md h-full', className)}>{children}</div>;
};

export const RightRailLayout = memo(RightRailLayoutBase);
